// CHA1-3190: which Requests sidebar groups are open. RequestsPage owns this state: a header click
// toggles the current tab's group or opens the tab being navigated to, and the route only seeds
// the value and follows a hash change that did not come from a click (direct URL, Back/Forward,
// redirects).

// Called on a tab (hash) change only: the canonical state for a route is exactly its own group.
// Returns the same array when it already is that, so the fallback costs no render after a click.
export const nextOpenKeys = (current, hash) => {
  if (!hash) return current
  if (current.length === 1 && current[0] === hash) return current
  return [hash]
}

// Header click on the current tab: close its group if open, open it otherwise.
export const toggleOpenKey = (current, key) =>
  current.includes(key) ? current.filter((item) => item !== key) : [...current, key]
